import { combineReducers, configureStore } from '@reduxjs/toolkit';
import administrationChannelsSlice from './administration/administrationChannels/administrationChannelsSlice';
import administrationUsersSlice from './administration/administrationUsers/administrationUsersSlice';
import businessUnitsSlice from './administration/businessUnits/businessUnitsSlice';
import customerResponsibilityMembersSlice from './administration/customerResponsibilityMembers/customerResponsibilityMembersSlice';
import erpCustomerCommunicationAssignmentSlice from './administration/erpCustomerAssignments/erpCustomerAssignmentsSlices';
import erpCustomersSlice from './administration/erpCustomers/erpCustomersSlice';
import globalSearchSlice from './administration/globalSearch/globalSearchSlice';
import houseBranchesSlice from './administration/houseBranches/houseBranchesSlice';
import houseCommunicationStructuresSlice from './administration/houseCommunicationStructures/houseCommunicationStructureSlices';
import houseSlice from './administration/houses/housesSlice';
import teamsSlice from './administration/teams/teamsSlice';
import tenantsSlice from './administration/tenants/tenantsSlice';
import attPermissionSlice from './attPermission/attPermissionSlice';
import authSlice from './auth/authSlice';
import channelListSlice from './channelList/channelListSlice';
import channelsSlice from './channels/channelsSlice';
import chatSlice from './chat/chatSlice';
import chatConnectionSlice from './chatConnection/chatConnectionSlice';
import craftsmanConnectionsSlice from './craftsmanConnections/craftsmanConnectionsSlice';
import currentAgentUserSlice from './currentAgent/currentAgentSlice';
import currentCraftsmanUserSlice from './currentCraftsmanUser/currentCraftsmanUserSlice';
import currentUserSlice from './currentUser/currentUserSlice';
import errorDialogSlice from './errorDialogSlice/errorDialogSlice';
import favoritesSlice from './favorites/favoritesSlice';
import fileListSlice from './fileList/fileListSlice';
import fileToAppSharingSlice from './fileToAppSharing/fileToAppSharingSlice';
import gccApiConnectionSlice from './gccApiConnection/gccApiConnectionSlice';
import googleAnalyticsSlice from './googleAnalytics/googleAnalyticsSlice';
import userHousesSlice from './houses/housesSlice';
import initSlice from './init/initSlice';
import memberDetailsSlice from './memberDetails/memberDetailsSlice';
import membersSlice from './members/membersSlice';
import messageInputSlice from './messageInput/messageInputSlice';
import messageSearchSlice from './messageSearch/messageSearchSlice';
import messagesSlice from './messages/messagesSlice';
import newChannelOptionsSlice from './newChannelOptions/newChannelOptionsSlice';
import processesSlice from './processes/processesSlice';
import quickOrderingSlice from './quickOrdering/quickOrderingSlice';
import salesSpaceChannelsSlice from './salesSpaceChannels/salesSpaceChannelsSlice';
import tasksSlice from './tasks/tasksSlice';
import themeSlice from './theme/themeSlice';
import ticketsSlice from './tickets/ticketsSlice';
import uiStateSlice from './uiState/uiStateSlice';
import usersSlice from './users/usersSlice';
import videosSlice from './videos/videosSlice';
import virtualScrollerSlice from './virtualScroller/virtualScrollerSlice';

export const commonReducers = {
  administrationChannels: administrationChannelsSlice,
  administrationUsers: administrationUsersSlice,
  attPermission: attPermissionSlice,
  auth: authSlice,
  businessUnits: businessUnitsSlice,
  channelList: channelListSlice,
  channels: channelsSlice,
  chat: chatSlice,
  chatConnection: chatConnectionSlice,
  craftsmanConnections: craftsmanConnectionsSlice,
  currentAgentUser: currentAgentUserSlice,
  currentCraftsmanUser: currentCraftsmanUserSlice,
  currentUser: currentUserSlice,
  customerResponsibilityMembers: customerResponsibilityMembersSlice,
  erpCustomerAssignments: erpCustomerCommunicationAssignmentSlice,
  erpCustomers: erpCustomersSlice,
  errorDialog: errorDialogSlice,
  favorites: favoritesSlice,
  fileList: fileListSlice,
  fileToAppSharing: fileToAppSharingSlice,
  gccApiConnection: gccApiConnectionSlice,
  globalSearch: globalSearchSlice,
  googleAnalytics: googleAnalyticsSlice,
  houseBranches: houseBranchesSlice,
  houseCommunicationStructures: houseCommunicationStructuresSlice,
  houses: houseSlice,
  init: initSlice,
  memberDetails: memberDetailsSlice,
  members: membersSlice,
  messageInput: messageInputSlice,
  messageSearch: messageSearchSlice,
  messages: messagesSlice,
  newChannelOptions: newChannelOptionsSlice,
  processes: processesSlice,
  quickOrdering: quickOrderingSlice,
  salesSpaceChannels: salesSpaceChannelsSlice,
  tasks: tasksSlice,
  teams: teamsSlice,
  tenants: tenantsSlice,
  theme: themeSlice,
  tickets: ticketsSlice,
  uiState: uiStateSlice,
  userHouses: userHousesSlice,
  users: usersSlice,
  videos: videosSlice,
  virtualScroller: virtualScrollerSlice,
};

// can be used for tests etc.
export const createStore = ({ preloadedState = {} } = {}) =>
  configureStore({
    reducer: combineReducers(commonReducers),
    preloadedState,
  });
